/**
 * 单页 vuex 配置
 */

export default {}
